/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface AnforderungDetailControllerDeleteAnforderungNotizV1$Params {
  anforderungsversionID: number;
  verlaufID: string;
}

export function anforderungDetailControllerDeleteAnforderungNotizV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerDeleteAnforderungNotizV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerDeleteAnforderungNotizV1.PATH, 'delete');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('verlaufID', params.verlaufID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

anforderungDetailControllerDeleteAnforderungNotizV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/notizen/{verlaufID}';
